const apiHost = 'https://api.eyefinity.com/lab-laborderapi-web/';

export const environment = {
  production: true,
  envName: 'prod',

  apiEndpoint: apiHost + 'laborders/',
  apiLabSearchEndpoint: apiHost + 'labordersearchrequestslab/',
  acsRedirectUrl: 'https://labportal.eyefinity.com/index.html',
  billerDirectUrl: 'https://secureb.eyefinity.com/ebill',
  vspOnlineUrl: 'https://labportal.eyefinity.com/comingSoon.html',
  oauthBaseUrl: 'api',
  lensCatalogApiEndpoint:
    'https://api.eyefinity.com/cataloglens-consumption-api/',
  dynaTraceUrl:
    'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf63206omp/5191a510e89f77b9_complete.js',
  paymentStatementsApiEndpoint:
    'https://api.eyefinity.com/eyefinity-lab-payment-docs',
  labLogonUrl: 'https://secure.eyefinity.com/eyefinity/html/eyefinity_lablogon.htm',
  welcomeLogOutUrl: 'https://portal.eyefinity.com/secure-welcome/logout-user',
  labRefManualUrl: 'https://www.vsplrm.com/',

};



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/environments/environment.ts